import React, {Component} from 'react';
import {connect} from 'react-redux';
import Select from 'react-select';

class FilterSecteur extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: null
    }
  }

  componentDidMount() {
    const secteur = this.props.secteurs.filter((secteur) => {
      return secteur.value === parseInt(this.props.value, 10);
    });

    if (secteur.length > 0) {
      this.setState({
        value: secteur[0]
      });
    }
  }

  onChange = (value) => {
    this.setState({ value: value });

    this.props.onChange({
      secteur: value?.value ?? null
    })
  };

  render() {
    return (
      <Select
        value={this.state.value}
        name="secteur"
        className={`filter-secteurs ${this.props.className}`}
        onChange={this.onChange}
        options={this.props.secteurs}
        placeholder="Choisissez un secteur"
      />
    );
  }
}

export default connect(
  (state) => ({
    secteurs: state.secteurs.secteurs.map(secteur => ({
      value: secteur.id,
      label: secteur.name
    }))
  })
)(FilterSecteur)